export var datePickerTheme = {
  baseStyle: _ref => {
    var {
      backButton,
      legendItems
    } = _ref;
    return {
      container: {
        borderRadius: 'l',
        overflow: 'hidden',
        width: {
          xs: '100%',
          s: 'min-content'
        }
      },
      calendarContainer: {
        paddingX: {
          xs: 'm',
          s: 's'
        },
        marginTop: {
          xs: 'none',
          s: backButton ? 's' : 'xs'
        },
        paddingBottom: backButton && legendItems ? 's' : 'none',
        position: 'relative'
      },
      backButton: {
        textStyle: 'body3Semi',
        textAlign: 'start',
        paddingX: 's',
        paddingTop: 'xs',
        paddingBottom: 's',
        _hover: {
          backgroundColor: 'neutral.lightest'
        },
        _focusVisible: {
          outlineColor: 'focus.focus',
          outlineWidth: '2px',
          outlineOffset: '-2px',
          transition: 'outline-color 0.2s'
        }
      }
    };
  }
};
//# sourceMappingURL=DatePicker.theme.js.map